import { sifrantService } from '../services/sifrant.service';
import Vue from 'vue';

const state = {
    sifrant: {},
    sezona:null
    
        


};
//naredi array arrayev šifrantov!

const actions = {
    load({ dispatch,commit },{sifrant,sezona}) {
         dispatch('alert/clear', "",{ root: true });
           commit('setSezona', sezona)
       return sifrantService.load(sifrant,sezona)
            .then(
                data => commit('load',{sifrant:data,name:sifrant})
            );
    },
    replace({ commit },{sifrant}) {
        commit('replace',sifrant);

    },

     save({ dispatch, commit },{sifrantItem,sifrant,sezona}) {
     

       dispatch('alert/clear', "",{ root: true });
          commit('setSezona', sezona)
         return sifrantService.save(sifrant,sifrantItem,sezona)
            .then(
                item => {
                    return sifrantService.load(sifrant,sezona)
                    .then(
                    data => {
                        commit('load',{sifrant:data,name:sifrant})
                        //return data;
                    }
                    );
                   
                    
                },
                error => {
                    console.log(error);
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
        
    }
};

const mutations = {
  
    load(state, payload) {
        Vue.set( state.sifrant, payload.name, payload.sifrant);
      //  state.sifrant[payload.name] = payload.sifrant;
    },
    replace(state, sifrant) {
        state.sifrant = sifrant;
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    update(state, sifrant,item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.sifrant[sifrant].findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.sifrant[sifrant].splice(index,1,updated);
            }
            else
                 state.sifrant[sifrant].push(item)


    }
   
};

export const sifrant = {
    namespaced: true,
    state,
    actions,
    mutations
};
